import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './LoginSignupCss.css';

function Signup() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [referenceId, setReferenceId] = useState('');
  const [role, setRole] = useState(''); // State to store selected role
  const [gender, setGender] = useState(''); // State for gender
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic Validation
    if (!firstName || !lastName || !email || !password || !confirmPassword || !role) {
      setError('Please fill in all fields.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      // Determine API URL based on selected role
      const apiUrl = role === 'user' ? 'https://earnistamart.online/usersignup' : 'https://earnistamart.online/vendorsignup';

      // Send signup request
      const response = await axios.post(apiUrl, {
        email,
        password,
        fname: firstName,
        lname: lastName,
        used_reference: referenceId || undefined, // Send undefined if not provided
        role,
        gender: role === 'vendor' ? gender : undefined, // Send gender if vendor
      });

      console.log('Signup response:', response); // Debugging line

      setSuccess('Signup successful! Redirecting to login...');
      setTimeout(() => {
        navigate('/LoginPage'); // Redirect to login page after 2 seconds
      }, 2000);

    } catch (err) {
      console.error('Signup error:', err); // Debugging line
      if (err.response && err.response.data.error) {
        setError(err.response.data.error);
      } else {
        setError('An unexpected error occurred.');
      }
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Signup</h2>
        {error && <p className="error-message">{error}</p>}
        {success && <p className="success-message">{success}</p>}
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>First Name</label>
            <input 
              type="text" 
              placeholder="Enter your First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
          <div className="input-group">
            <label>Last Name</label>
            <input 
              type="text" 
              placeholder="Enter your Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          
          {/* Conditionally render the Gender field for Vendors */}
          {role === 'vendor' && (
            <div className="input-group">
              <label>Gender</label>
              <select 
                value={gender}
                onChange={(e) => setGender(e.target.value)}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
          )}

          <div className="input-group">
            <label>Email</label>
            <input 
              type="email" 
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-group">
            <label>Create Password</label>
            <input 
              type="password" 
              placeholder="Create a password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="input-group">
            <label>Confirm Password</label>
            <input 
              type="password" 
              placeholder="Confirm your password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <div className="input-group">
            <label>Reference ID</label>
            <input 
              type="text" 
              placeholder="Enter Your Reference ID (optional)"
              value={referenceId}
              onChange={(e) => setReferenceId(e.target.value)}
            />
          </div>

          {/* Radio buttons for selecting role */}
          <div className="radio-group">
            <label>
              <input 
                type="radio" 
                value="user" 
                checked={role === 'user'}
                onChange={(e) => setRole(e.target.value)}
              />
              User
            </label>
            <label style={{marginLeft:'10px'}}>
              <input 
                type="radio" 
                value="vendor" 
                checked={role === 'vendor'}
                onChange={(e) => setRole(e.target.value)}
              />
              Vendor
            </label>
          </div>

          <button type="submit" className="auth-button">Signup</button>
        </form>
        <Link to="/LoginPage">
          <p className="redirect-text">
            Already have an Account? Login
          </p>
        </Link>
      </div>
    </div>
  );
}

export default Signup;
